import { NotificationsOutlined } from "@mui/icons-material";
import { Badge, Grid, IconButton, Menu } from "@mui/material";
import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Notifications } from "../../Notifications/Notifications";
import { useAppDispatch, useAppSelector } from "../../../Redux/store";
import { useDeleteNotificationsMutation } from "../../../Redux/api/notificationApi";
import { useUser } from "../../../Hooks/useUser";
import { setHasNotifications } from "../../../Redux/slices/NotificationSlice";

interface SettingsHamburgerProps {
    // mode: PaletteMode;
    // pages: VerticalNavbarItem[]
}

export const NotificationsHamburger = ({ }: SettingsHamburgerProps) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const { locator } = useUser();
    const [deleteNotification] = useDeleteNotificationsMutation();
    const dispatch = useAppDispatch();
    /* ******************** Variables ******************** */
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const notificationSlice = useAppSelector( state => state.Notification);
    /* ******************** Functions ******************** */
    const handeMenuOpen = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    } 
    const handeMenuClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
        if(notificationSlice.read.length > 0) deleteNotification({locator: locator!, body: notificationSlice.read});
        if (notificationSlice.count === notificationSlice.read.length) dispatch(setHasNotifications(false));
    }
    const handleNavClick = (link: string) => {
        navigate(`/${link}`)
        handeMenuClose();
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid  item display={"flex"} justifyContent={"flex-end"} alignItems={"center"} flex={1}>
                <IconButton color="primary" onClick={handeMenuOpen}>
                    <Badge 
                        color="info" 
                        invisible={!notificationSlice.hasNotifications}
                        variant="dot"
                    >
                        <NotificationsOutlined color="primary" sx={{fontSize: '18px'}}/>
                    </Badge>
                </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handeMenuClose}
                sx={{
                    '.MuiList-root': {
                        padding: 0
                    }
                }}
            >
                <Notifications />
            </Menu>
        </Grid>
    )
}